import {
    hasFlow,
    type FlowGroupId,
    type LatestFlow,
    type LatestFlowByMarket,
} from './groups';

function compactUsd(value: number): string {
    const abs = Math.abs(value);
    if (abs >= 1_000_000) return `$${(abs / 1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `$${(abs / 1_000).toFixed(0)}k`;
    return `$${abs.toFixed(0)}`;
}

export function formatNetCapital(flow: LatestFlow): string {
    if (flow.netCapital === 0) return `${compactUsd(0)} net`;
    return `${compactUsd(flow.netCapital)} ${flow.netCapital > 0 ? 'YES' : 'NO'}`;
}

export function formatWallets(count: number): string {
    return `${count} wallet${count === 1 ? '' : 's'}`;
}

export function marketsWithFlow(
    byMarket: LatestFlowByMarket,
    marketIds: readonly string[],
    group: FlowGroupId
): string[] {
    return marketIds.filter(id => hasFlow(byMarket.get(id)?.get(group)));
}

export function flowRank(
    byMarket: LatestFlowByMarket,
    marketId: string | null
): number {
    const flow = marketId ? byMarket.get(marketId) : undefined;
    const informed = flow?.get('informed');
    const whales = flow?.get('whales');
    if (hasFlow(informed)) return 2 + Math.abs(informed?.netCapital ?? 0);
    if (hasFlow(whales)) {
        return 1 - 1 / (1 + Math.abs(whales?.netCapital ?? 0));
    }
    return 0;
}

export function anyFlow(
    byMarket: LatestFlowByMarket,
    marketIds: readonly string[]
): boolean {
    return marketIds.some(id => {
        const flow = byMarket.get(id);
        return hasFlow(flow?.get('informed')) || hasFlow(flow?.get('whales'));
    });
}
